const getMediaObj = ({ hoosObj }) => {
    let { media, variants } = hoosObj.product;
    let availableVariants = hoosObj.availableVariants;
    const mediaObj = {};
    for (let i = 0; i < media.length; i++) {
        const item = media[i];
        // let soldout = idx !== 0;
        let soldout = false;

        const attachedWithVariants = variants.filter(v => v.featured_media && v.featured_media.id == item.id).map(v => v.id);
        let image_id;
        if (attachedWithVariants.length) {
            let temp = availableVariants.find(v => attachedWithVariants.includes(v.id));
            if (temp === undefined) {
                soldout = true;
            } else if(temp.featured_image) {
                image_id = temp.featured_image ? temp.featured_image.id: null;
            }

            if(!image_id) {
                let temp2 = variants.find(v => v.featured_media && v.featured_image && (v.featured_media.id == item.id));
                image_id = (temp2 && temp2.featured_image) ? temp2.featured_image.id: image_id;
            }
        } else if (i !== 0) {
            soldout = mediaObj[media[i - 1].id].soldout;
        }
        mediaObj[item.id] = { id: item.id, media_type: item.media_type, image_id: image_id, index: i, soldout };
    }

    return mediaObj;
};

const hideProductImages = ({ hoosObj }) => {
    const mediaObj = getMediaObj({ hoosObj });
    const thumbnails = document.querySelectorAll('#thumbnails .image-thumbnail');
    for (const thumbnail of thumbnails) {
        const id = thumbnail.getAttribute('data-image-id');
        for(const key in mediaObj) {
            if ((mediaObj[key].id == id) && mediaObj[key].soldout) {
                thumbnail.remove();
            }
        }
    }
};


async function startImageHide() {
  const temp = await fetch(`${location.origin + location.pathname}.js`);
  const product = await temp.json();
  const availableVariants = product.variants.filter(v => v.available);

  hideProductImages({
      hoosObj: {
          product,
          availableVariants
      }
  });
}

if (window.CAMOUFLAGEE) {
    // when camouflage is installed

    hideProductImages({ hoosObj: window.CAMOUFLAGEE.items[0] });
} else {
    // when camouflage is not installed
    startImageHide();
}
